import { styled } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

export const ptBRLocaleText = {
    columnMenuSortAsc: 'Ordenar crescente',
    columnMenuSortDesc: 'Ordenar decrescente',
    columnMenuFilter: 'Filtrar',
    columnMenuHideColumn: 'Esconder coluna',
    columnMenuUnsort: 'Desordenar',
    columnMenuManageColumns: 'Gerenciar colunas',
    columnsPanelTextFieldLabel: 'Encontrar coluna',
    columnsPanelTextFieldPlaceholder: 'Título da coluna',
    columnsPanelDragIconLabel: 'Reordenar coluna',
    columnsPanelShowAllButton: 'Mostrar tudo',
    columnsPanelHideAllButton: 'Esconder tudo',
    footerTotalRows: 'Total de linhas:',
    checkboxSelectionSelectAllRows: 'Selecionar todas as linhas',
    checkboxSelectionUnselectAllRows: 'Deselecionar todas as linhas',
    checkboxSelectionSelectRow: 'Selecionar linha',
    checkboxSelectionUnselectRow: 'Deselecionar linha',
    actionsCellMore: 'Mais',
    toolbarDensity: 'Densidade',
    toolbarDensityLabel: 'Densidade',
    toolbarDensityCompact: 'Compacta',
    toolbarDensityStandard: 'Padrão',
    toolbarDensityComfortable: 'Confortável',
    toolbarColumns: 'Colunas',
    toolbarColumnsLabel: 'Selecionar colunas',
    toolbarFilters: 'Filtros',
    toolbarFiltersLabel: 'Mostrar filtros',
    toolbarFiltersTooltipHide: 'Esconder filtros',
    toolbarFiltersTooltipShow: 'Mostrar filtros',
    toolbarQuickFilterPlaceholder: 'Procurar…',
    toolbarQuickFilterLabel: 'Procurar',
    noRowsLabel: 'Nenhum cliente cadastrado.'
};

export const CustomerDataGrid = styled(DataGrid)({
    width: '100%',
    borderRadius: 0,

    '& .MuiDataGrid-columnHeader': {
        backgroundColor: '#F5F5F7',
        color: '#4C4E64',
    }
}
)

